module.exports = __webpack_public_path__ + "e6113d70e1668ab4d0e15e8430e8c2a9.png";